// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closeBtn[data-v-92888500]{cursor:pointer}.actionBackgroundGray[data-v-92888500]{background-color:hsla(0,0%,66.3%,.1)}.actionBorderBottom[data-v-92888500]{border-top:.5px dotted grey}", ""]);
// Exports
module.exports = exports;
